import { Warehouse } from './warehouse.model';

export class WarehouseLocation {
  id: number = -1;

  warehouseId: number = -1;
  warehouse: Warehouse = new Warehouse();

  aisle: string = '';
  shelf: string = '';
  description: string = '';

  createdBy: number = -1;
  createdAt: string = '';
  updatedAt: string = '';
}
